<template>
    <section class="bg-[#f7f4ef] text-[#171717]">
        <div class="mx-auto max-w-7xl px-5 pb-14 lg:px-12">
            <div class="rounded-[2rem] border border-black/10 bg-white/60 p-6 shadow-sm md:p-8">
                <div class="grid gap-8 md:grid-cols-[0.9fr_1.1fr] md:items-center">
                    <div>
                        <div class="text-xs uppercase tracking-[0.35em] text-[#b49d7c]">
                            {{ t.cadastre.badge }}
                        </div>

                        <h2 class="mt-4 font-serif text-3xl uppercase leading-tight md:text-4xl">
                            {{ t.cadastre.title }}
                        </h2>

                        <p class="mt-4 max-w-xl text-sm leading-7 text-black/60">
                            {{ t.cadastre.text }}
                        </p>
                    </div>

                    <div class="grid gap-4 xl:grid-cols-2">
                        <div
                            v-for="item in t.cadastre.items"
                            :key="item.number"
                            class="rounded-3xl border border-black/10 bg-[#111] p-6 text-white"
                        >
                            <div class="text-xs uppercase tracking-[0.28em] text-[#c7ad83]">
                                {{ item.title }}
                            </div>

                            <div class="mt-5 break-all font-serif text-2xl leading-tight">
                                {{ item.number }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { useHomeStore } from '@js/store/homeStore.js';

export default {
    name: 'CadastralNumbersSection',

    computed: {
        homeStore() {
            return useHomeStore();
        },

        locale() {
            return this.homeStore.getLocale(this.$page);
        },

        t() {
            return this.homeStore.getTranslations(this.locale);
        },
    },
};
</script>
